export const getLettersForUserName = (name: string) => {
  const names = name.split(" ");
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  return names
    .map((n) => n.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");
};
